import React from 'react';
import './navBar.scss';
import CloseIcon from '../../../assets/images/close.svg';
import { Link } from 'react-router-dom';
const NavBar = () => {
    return (
        <div className="workingTemplateNavBar">
            <div className="leftContainer">
                <Link to="/working-template">
                    <div className="closeIconWrapper">
                        <img src={CloseIcon} alt="close" />
                    </div>
                </Link>
            </div>

            <div className="rightContainer">
                <div className="cancellation">취소</div>
                <div className="nextButton">저장</div>
            </div>
        </div>
    );
};

export default NavBar;
